import { render, staticRenderFns } from "./VaccineRegistrationPage.vue?vue&type=template&id=c1b16ce2&"
import script from "./VaccineRegistrationPage.vue?vue&type=script&lang=js&"
export * from "./VaccineRegistrationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1b16ce2')) {
      api.createRecord('c1b16ce2', component.options)
    } else {
      api.reload('c1b16ce2', component.options)
    }
    module.hot.accept("./VaccineRegistrationPage.vue?vue&type=template&id=c1b16ce2&", function () {
      api.rerender('c1b16ce2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineRegistrationPage/VaccineRegistrationPage.vue"
export default component.exports